import {StyleSheet} from 'react-native';
import {Colors} from '../../../constants/Colors';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'white',
    paddingHorizontal: 40,
    paddingTop: 50,
    paddingBottom: 10,
    marginVertical: 30,
    marginHorizontal: 15,
    borderRadius: 8,
    maxWidth: 600,
    alignSelf: 'center',
    width: '100%',
  },
  validation: {
    textAlign: 'center',
    marginTop: 30,
    color: 'black',
    fontFamily: 'TCCC-UnityHeadline Regular',
  },
  validation_link: {
    color: Colors.RedPallete.red,
    fontFamily: 'TCCC-UnityHeadline Regular',
  },
  resend_token: {
    textAlign: 'center',
    marginTop: 5,
    fontFamily: 'TCCC-UnityHeadline Regular',
    color: Colors.RedPallete.red,
  },
  call: {
    textAlign: 'center',
    fontSize: 12,
    fontWeight: '400',
    lineHeight: 20,
    alignSelf: 'center',
    marginTop: 30,
    fontFamily: 'TCCC-UnityHeadline Regular',
    color: Colors.GrayPallete.lightgrayThree,
  },
  number: {
    textAlign: 'center',
    fontSize: 12,
    fontWeight: '400',
    lineHeight: 20,
    alignSelf: 'center',
    fontFamily: 'TCCC-UnityHeadline Regular',
    color: Colors.GrayPallete.lightgrayThree,
  },
  imageBackground: {
    flex: 1,
    backgroundColor: '#e61c2b'
  },
  simbol: {alignSelf: 'center', marginBottom: 50, width: 80, height: 120},
  containerButton: {marginTop: 30},
  biometricButton: {marginTop: 15},
  containerCheckBox: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 20,
  }
});
